import styles from "./learningAdaptiveTestChoice.module.scss";
import classNames from "classnames";

export const LearningAdaptiveTestChoice = (props: Props) => {
  const { label, onClick, isActive } = props;

  return (
    <div
      className={classNames(styles["container"], {
        [styles["active"]]: isActive,
      })}
      onClick={onClick}
    >
      <div className={styles["shape"]}>
        <div
          className={classNames(styles["circle"], styles["circleStart"])}
        ></div>
        <div
          className={classNames(styles["circle"], styles["circleEnd"])}
        ></div>
      </div>
      <span className={styles["label"]}>{label}</span>
    </div>
  );
};

interface Props {
  label: string;
  onClick: () => void;
  isActive?: boolean;
}
